import { render, staticRenderFns } from "./StudyBreadcrumb.vue?vue&type=template&id=25f396c0&functional=true&"
import script from "./StudyBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./StudyBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports